import * as React from "react";
import { forwardRef } from "react";
const SvgPauseMessage = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 14, viewBox: "0 0 10 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0, width: 4, height: 14, rx: 2, fill: "#B5C0E0" }), /* @__PURE__ */ React.createElement("rect", { x: 5, width: 4, height: 14, rx: 2, fill: "#B5C0E0" }));
const ForwardRef = forwardRef(SvgPauseMessage);
export default ForwardRef;
